const FULL_FMT = new Intl.DateTimeFormat('en-GB', {
	day: 'numeric',
	month: 'short',
	year: 'numeric',
	timeZone: 'UTC',
});

const SHORT_FMT = new Intl.DateTimeFormat('en-GB', {
	day: 'numeric',
	month: 'short',
	timeZone: 'UTC',
});

/**
 * Local time, deliberately: unlike the date-only formatters above, a timestamp with
 * an hour on it is read as "when, for me" — an SLA due at 17:00 rendered in UTC is
 * wrong by the reader's offset. No year, to keep the dashboard's columns narrow: they
 * are read inside a chosen period, which is usually but not always within one year.
 */
const DATE_TIME_FMT = new Intl.DateTimeFormat('en-GB', {
	day: 'numeric',
	month: 'short',
	hour: '2-digit',
	minute: '2-digit',
	hour12: false,
});

/**
 * An absolute date and time without the year — `23 Aug, 17:00`. For timestamps
 * read inside a chosen period, including ones that may be in the future (an SLA due
 * moment). A period can still cross a year boundary (a custom range, or the last 30
 * days in early January), where `28 Dec` and `3 Jan` do not say which year; use
 * `formatCreated` wherever the year has to be unambiguous.
 *
 * Returns an em-dash for a missing or unparseable value, so a cell always has text.
 */
export function formatDateTime(iso: string | null | undefined): string {
	if (!iso) return '—';
	const date = new Date(iso);
	if (isNaN(date.getTime())) return '—';
	return DATE_TIME_FMT.format(date);
}

export function formatDateFull(iso: string): string {
	return FULL_FMT.format(new Date(iso));
}

export function formatDateShort(iso: string): string {
	return SHORT_FMT.format(new Date(iso));
}
